import { render, staticRenderFns } from "./InformItem.vue?vue&type=template&id=5b3d9c10&"
import script from "./InformItem.vue?vue&type=script&lang=js&"
export * from "./InformItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports